module.exports = function() {
  return new Worker(__webpack_public_path__ + "d3a39a286d3eea2bd0ef.worker.js");
};